<template>
  <div class="sim-task-summary" role="region" :aria-label="translate('sim_task.compact.summary')">
    <div class="sim-task-summary__heading">
      <h4>{{ translate('sim_task.compact.summary') }}</h4>
      <span>{{ translate('sim_task.compact.total') }}: <strong>{{ summary.total }}</strong></span>
    </div>
    <div class="sim-task-summary__group">
      <div class="sim-task-summary__label">{{ translate('sim_task.compact.execution') }}</div>
      <div class="sim-task-summary__counters">
        <div v-for="counter in executionCounters" :key="counter.key" class="sim-task-summary__counter" :class="'tone-' + counter.key">
          <span>{{ translate('sim_task.compact.states.' + counter.key) }}</span><strong>{{ counter.value }}</strong>
        </div>
      </div>
    </div>
    <div v-if="isApnControl" class="sim-task-summary__group">
      <div class="sim-task-summary__label">{{ translate('sim_task.compact.result') }}</div>
      <div class="sim-task-summary__counters">
        <div v-for="counter in resultCounters" :key="counter.key" class="sim-task-summary__counter" :class="'tone-' + counter.key">
          <span>{{ translate('sim_task.compact.results.' + counter.key) }}</span><strong>{{ counter.value }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SimTaskSummary',
  props: {
    summary: { type: Object, required: true },
    isApnControl: { type: Boolean, default: false }
  },
  computed: {
    executionCounters () {
      const primary = ['pending', 'in_progress', 'waiting', 'completed', 'failed']
      return this.counters(this.summary.execution, primary.concat(['retry', 'cancelled', 'timed_out', 'other']), primary)
    },
    resultCounters () {
      return this.counters(this.summary.results, ['not_checked', 'apn_present', 'apn_missing', 'other'], ['not_checked', 'apn_present', 'apn_missing'])
    }
  },
  methods: {
    counters (values, keys, primary) {
      return keys.map(key => ({ key, value: values && values[key] != null ? values[key] : 0 }))
        .filter(counter => primary.includes(counter.key) || counter.value > 0)
    }
  }
}
</script>
<style scoped>
.sim-task-summary { height: auto; min-height: 0; flex: 0 0 auto; padding: 10px 12px; margin-bottom: 12px; border: 1px solid #e4e8eb; border-radius: 6px; background: #fafbfc; }
.sim-task-summary__heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.sim-task-summary__heading h4 { margin: 0; font-size: 14px; font-weight: 600; }
.sim-task-summary__group { display: flex; align-items: center; gap: 10px; margin-top: 8px; }
.sim-task-summary__label { flex: 0 0 130px; font-size: 12px; color: #68757d; }
.sim-task-summary__counters { display: flex; flex-wrap: wrap; gap: 6px; min-width: 0; }
.sim-task-summary__counter { display: flex; gap: 8px; align-items: center; padding: 4px 8px; background: white; border: 1px solid #e4e8eb; border-radius: 4px; font-size: 12px; line-height: 18px; }
.sim-task-summary__counter strong { font-size: 14px; font-variant-numeric: tabular-nums; }
.tone-completed strong, .tone-apn_present strong { color: #25643c; }
.tone-failed strong, .tone-timed_out strong { color: #9d3434; }
.tone-waiting strong, .tone-retry strong, .tone-apn_missing strong { color: #805e18; }
@media (max-width: 600px) {
  .sim-task-summary__group { flex-direction: column; align-items: flex-start; gap: 4px; }
  .sim-task-summary__label { flex-basis: auto; }
}
</style>
